import { Box, Divider, Step, StepContent, StepLabel, Stepper } from "@mui/material";
import { ParagraphText, UBButton } from "../../../Libraries";
import { Fragment, useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { ArrowIcon, Camera, PhoneIcon, PhoneNewIcon, PhoneWhiteIcon, PlayStore, QRICON, Scan, UdhaarLogo, VerifyAccountIcon } from "../../../assets/icons/icon";
import { HeaderRupin } from "../../common";
import { Grid } from "@mui/material";
import qrCode from "./../../../assets/images/qrCode.png";
import { handleCheckKYC } from "../../../SyncService";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import FooterRupin from "../../common/FooterRupin";
import styles from "./styles.module.css";
import { InvoiceBookNonIdeal } from "../../common/NewNonIdeal";
import NonIdealNew from "../../common/NonIdealNew";
import ChatwootWidget from "../../common/Chatwoot";
import { openChatwootWindow } from "../../../utils/chatwoot";


const VerifyAccount = ({ phone, backToLogin, isSuspended, isFromForget }) => {
  const [I18n] = useContext(LanguageContext);
  const [isChatWidgetOpen, setIsChatWidgetOpen] = useState(false);

  const steps = [
    {
      label: (
        <ParagraphText className={`fontSize14 newFontColor ${styles.stepper}`}>
          {I18n.open_camera}&nbsp; <Camera /> &nbsp;
          {I18n.and_scan_barcode}&nbsp;&nbsp;
          <QRICON />
          &nbsp;&nbsp;{I18n.from_your_phone}
        </ParagraphText>
      ),
    },
    {
      label: (
        <ParagraphText className={`fontSize14 newFontColor ${styles.stepper}`}>
          {I18n.download}&nbsp;&nbsp; <UdhaarLogo width={24} height={24} /> &nbsp;&nbsp;
          {I18n.udhaar_book_app_from}&nbsp;&nbsp;
          <PlayStore width={24} height={24} />
          &nbsp;&nbsp;{I18n.play_store}
        </ParagraphText>
      ),
    },
    {
      label: (
        <ParagraphText className={`fontSize14 newFontColor ${styles.stepper}`}>
          Log in with your registered phone number.
        </ParagraphText>
      ),
    },
    {
      label: (
        <ParagraphText className={`fontSize14 newFontColor ${styles.stepper}`}>
          Complete CNIC and selfie verification.
        </ParagraphText>
      ),
    },
    {
      label: (
        <ParagraphText className={`fontSize14 newFontColor ${styles.stepper}`}>
          Return here and try again. Verification usually takes a few minutes
        </ParagraphText>
      ),
    },
  ];



  const handleCallSupport = () => {
    triggerLogEvent(analytics, "login_call_support");
    setIsChatWidgetOpen(true);
    openChatwootWindow();
  };
  const handlePlayStoreLink = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.oscarudhaarapp&hl=en",
      "_blank"
    );
  }

  return (
    <Box className={`${styles.VerifyAccountContainer} onBoardingScreenWrapper`}>
      <HeaderRupin  >
        <Box className={styles.contactSupport} onClick={handleCallSupport}> <ParagraphText>{I18n.need_help} <span className="marginLeft5 barclayBlueColor">{I18n.chat_with_us}</span> <ArrowIcon /></ParagraphText></Box>
      </HeaderRupin>
      {/* User is not logged in here, so identify the Chatwoot contact by the login phone */}
      {isChatWidgetOpen ? <ChatwootWidget user={{ phone_number: phone }} /> : null}
      <Grid container flex={1} className={styles.verifyAccountScroll}>
        <Grid item md={12} className={styles.VerifyAccountGrid}>
          {isSuspended ?
              <NonIdealNew
                customClassName={styles.nonIdealVerifyAccount}
                title={I18n.account_temporarily_locked}
                subtitle={
                  I18n.account_temporarily_locked_OTP_desc
                }
                button1Title={I18n.contact_support}
                onButton1Click={() => handleCallSupport()}
                // prefixIconButtonOne={<PhoneWhiteIcon />}
                iconPlacementBtn1="left"
              />
            : <Fragment>
              <Grid container className={styles.VerifyGridAccount}>
                <Grid item md={5}>
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    flexDirection={"column"}
                  >
                    <ParagraphText className={"fontSize24 fontWeight500 newFontColor"}>{isFromForget ? I18n.verify_your_account : I18n.account_temporarily_locked}</ParagraphText>
                    <Box mb={"10px"} />
                    <ParagraphText className={"fontSize14 newLightColor textCenter"}>
                      {isFromForget
                        ? I18n.verify_your_account_decs
                        : I18n.account_temporarily_locked_PIN_desc}
                    </ParagraphText>
                  </Box>
                </Grid>
              </Grid>
              <Box mb={"34px"} />
              <Box className={styles.AccountVerifyCTA}>

                <UBButton
                  id="verify_account_continue_btn"
                  onClick={handlePlayStoreLink}
                  title={"download udhaar book app"}
                  className={`ubPrimaryButton ${styles.playstoreButton}`}
                  iconComponent={<PlayStore />}
                />

              </Box>

              <Box className={styles.udhaarBookAppBox}>
                <ParagraphText className={"fontSize18 fontWeight500 newFontColor"}>
                  {I18n.scan_download_app}
                </ParagraphText>
                <Box className={styles.activateModalBody}>
                  <Stepper
                    className="activateSteps"
                    activeStep={-1}
                    sx={{ maxWidth: 500 }}
                    orientation="vertical"
                  >
                    {steps.map((step) => (
                      <Step key={step.label}>
                        <StepLabel>{step.label}</StepLabel>
                        <StepContent>
                          <ParagraphText>{step.description}</ParagraphText>
                        </StepContent>
                      </Step>
                    ))}
                  </Stepper>
                  <Box
                    className={styles.QRContainer}>
                    <Box
                      className={styles.QRContainerInner} >
                      <img src={qrCode} width={"90%"} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Fragment>
          }


        </Grid>

      </Grid>
    </Box>
  );
};
export default VerifyAccount;
